export default "__VITE_ASSET__Dl_$ULVW__"